<template>
  <div class="top">
    <div class="video-box">
      <img
        v-if="isMinScreen"
        class="video-mark"
        src="@/assets/images/index/h5-video-mark.png"
      />
      <img
        v-else
        class="video-mark"
        src="@/assets/images/index/pc-video-mark.png"
      />
      <video
        v-if="isMinScreen"
        class="video"
				ref="loadingVideoRef"
        x-webkit-airplay="allow"
				webkit-playsinline="true"
				playsinline="true"
				x5-playsinline="true"
				x5-video-player-type="h5"
				x5-video-player-fullscreen="true"
				x5-video-orientation="portraint"
				t7-video-player-type="inline"
				playsInline
				preload="none"
				autoplay
				muted
				loop
				controlslist="nodownload nofullscreen"
        :src="h5Video"
      ></video>
      <video
        v-else
        class="video"
        :src="pcVideo"
        autoplay
        loop
        muted
        playsinline
        preload="none"
      ></video>
    </div>
    <div class="top-list2">
      <div class="title">
        <h1>Tokyo Ghoul : Break the Chains</h1>
        <h3>Official Tokyo Ghoul RPG</h3>
      </div>
      <img class="swiper-button-prev pc" src="~@/assets/images/prev.png" />
      <img class="swiper-button-next pc" src="~@/assets/images/next.png" />
      <div class="product-main">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in resDatas.gamelist"
            >
              <a href="https://web.funcatgames.com/" target="_blank">
                <img
                  :src="require('@/assets/images/store/' + item.img + '.jpg')"
                  alt=""
                />
              </a>
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.min.css";
import Swiper from "swiper";
import pcVideo from "@/assets/images/index/pc-video.mp4";
import h5Video from "@/assets/images/index/h5-video.mp4";
import tools from "@/utils/tools";
export default {
  data() {
    return {
      pcVideo,
      h5Video,
      resDatas: "",
      tt: "",
      isMinScreen: false,
      mySwiper: null,
      isWeChat: tools.getDeviceInfo().isWeChat
    };
  },
  props: {
    resData: {}
  },
  watch: {
    resData(newData) {
      this.resDatas = newData;
      if (this.isMinScreen) {
        this.initMySwiperH5();
      } else {
        this.initMySwiperPc();
      }
    }
  },
  mounted() {
    let ua = navigator.userAgent.toLowerCase();
    console.log("ua", ua.match(/MicroMessenger/i));
    this.tt = ua;
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      console.log(ua.match(/MicroMessenger/i));
      this.tt = 111;
    }

    this.$parent.getlan();

    this.onVideoCanPlayThrough();

    this.screenWidth();
    window.onresize = () => {
      this.screenWidth();
    };
  },
  onUnmounted() {
    window.onresize = null;
  },
  methods: {
    screenWidth() {
      const screenWidth = window.innerWidth;
      if (screenWidth <= 1000) {
        this.isMinScreen = true;
      } else {
        this.isMinScreen = false;
      }

      setTimeout(() => {
        if (this.isMinScreen) {
          this.initMySwiperH5();
        } else {
          this.initMySwiperPc();
        }
      }, 500);
    },

    onVideoCanPlayThrough() {
      this.$nextTick(() => {
        if (!this.isWeChat) {
          this.$refs['loadingVideoRef'] && this.$refs['loadingVideoRef'].play();
        } else {
          tools.onBridgeReady(() => {
            this.$refs['loadingVideoRef'] && this.$refs['loadingVideoRef'].play();
          });
        }
      });
    },

    initMySwiperPc() {
      this.$nextTick(() => {
        this.mySwiper = new Swiper(".swiper-container", {
          slidesPerView: 2,
          spaceBetween: 30,
          pagination: {
            el: ".swiper-pagination",
            clickable: true
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          }
        });
      });
    },

    initMySwiperH5() {
      this.$nextTick(() => {
        this.mySwiper = new Swiper(".swiper-container", {
          slidesPerView: 1,
          slidesPerColumn: 2,
          spaceBetween: 10,
          pagination: {
            el: ".swiper-pagination",
            clickable: true
          }
        });
      });
    }
  }
};
</script>

<style scoped>
.top {
  width: 100%;
  height: 100%;
  position: relative;
  text-align: center;
  overflow: hidden;
}

.video-box {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 1200px;
  background: #000;
}

.video {
  width: 100%;
  height: 800px;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
}

.video-mark {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
  left: 0;
  top: 0;
}

.top-list2 {
  width: 80%;
  margin: auto;
  position: absolute;
  z-index: 2;
  box-sizing: border-box;
  bottom: 10%;
  left: 10%;
  padding: 2%;
  background-image: url("~@/assets/images/pc-content-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.top-list2 .title {
  position: absolute;
  top: -40%;
  color: #fff;
  text-align: left;
}

.top-list2 .title h1 {
  font-size: 60px;
  font-family: "btfont";
}

.top-list2 .title h3 {
  font-size: 30px;
  opacity: 0.5;
  font-family: "btfont";
}

.swiper-container {
  width: 100%;
  height: 400px;
  margin-left: auto;
  margin-right: auto;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.swiper-slide img {
  width: 100%;
  height: 100%;
  border-radius: 6px;
}

.swiper-pagination {
  bottom: -10%;
  left: 0;
  width: 100%;
}

.pc {
  display: block !important;
}

.swiper-button-prev,
.swiper-button-next {
  background-image: url();
  width: 66px;
  height: 66px;
  top: 50%;
  z-index: 5;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}

.swiper-button-prev {
  left: -9%;
}

.swiper-button-next {
  right: -9%;
}

@media screen and (max-width: 1000px) {
  .video-box {
    height: 1300px;
  }

  .video-mark {
    top: 60px;
  }

  .video {
    height: 700px;
    top: 0;
  }

  .swiper-pagination {
    left: 0;
    width: 100%;
  }

  .pc {
    display: none !important;
  }

  .top-list2 {
    padding: 4%;
    background-image: url("~@/assets/images/h5-content-bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    bottom: auto;
    top: 450px;
    width: 90%;
    left: 5%;
  }

  .top-list2 .title {
    top: -12%;
    left: 0;
    width: 100%;
  }

  .top-list2 .title h1 {
    font-size: 32px;
  }

  .top-list2 .title h3 {
    font-size: 14px;
  }

  .swiper-container {
    height: auto;
  }

  .swiper-slide {
    height: auto;
    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
  }
}

@media screen and (max-width: 600px) {
  .video-box {
    height: 1200px;
  }
  .top-list2 .title h1 {
    font-size: 28px;
  }
}

@media screen and (max-width: 530px) {
  .video-box {
    height: 1100px;
  }
  .top-list2 .title h1 {
    font-size: 24px;
  }
}

@media screen and (max-width: 430px) {
  .video-box {
    height: 900px;
  }
  .video {
    top: -80px;
  }
  .top-list2 {
    top: 390px;
  }
  .top-list2 .title {
    top: -20%;
  }
  .top-list2 .title h1 {
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/top.vue